import * as React from 'react';
import px from 'prop-types';
import ProductPrice from '../../ProductPrice';
import { useTranslation } from 'Common/hooks';
import { Translation } from 'Common/components/localization';
import BulkAddToCart from './BulkAddToCart';

export default function BuyBulkSummary({
    addToCartTip,
    cartIsUpdating,
    clearAllInputs,
    facets,
    getFacetValueForProduct,
    getImageUrl,
    isLoading,
    isMobile,
    onBulkAddToCart,
    selectedItems,
    updateRow,
}) {
    const summaryTitleLabel = useTranslation('Commerce.Product.Tabs.BuyInBulk.Summary.Title');
    const clearItemsLabel = useTranslation('Commerce.Product.Tabs.BuyInBulk.ClearAll.Label');

    return (
        <div
            className="cart-summary-section mt-4 bg-light rounded"
            style={{
                marginBottom: `${!isMobile ? '60px' : ''}`,
                padding: `${!isMobile ? '1rem 1rem 2rem 1rem' : '1rem'}`,
                borderBottom: `${!isMobile ? '2rem solid white' : ''}`,
            }}
        >
            <h5 className="mb-3">
                <Translation id={summaryTitleLabel} defaultValue="Cart Summary" />
                <span className="badge badge-primary ms-2">{selectedItems?.stats.totalQuantity}</span>
            </h5>

            <div className="summary-items">
                {selectedItems?.items.map((item) => (
                    <div
                        key={item.id}
                        className="summary-item d-flex align-items-center justify-content-between mb-2 p-2 bg-white rounded border"
                    >
                        <div className="d-flex align-items-center flex-grow-1">
                            <img
                                className="thumbnail me-3"
                                src={getImageUrl(item.productData.imageUrl, 40, 60)}
                                aria-hidden
                                alt=""
                                style={{ width: '40px', height: '60px', objectFit: 'cover' }}
                            />
                            <div className="item-details">
                                <div className="item-id text-muted small">{item.id}</div>
                                {facets.map((facet) => {
                                    const facetValue = getFacetValueForProduct(item.productData, facet.Attribute);

                                    if (facetValue && facetValue !== '-') {
                                        return (
                                            <div key={facet.Attribute} className="item-facet text-muted small">
                                                {facet.AttributeDisplayName || facet.Attribute}: {facetValue}
                                            </div>
                                        );
                                    }
                                    return null;
                                })}
                            </div>
                        </div>

                        <div className="item-quantity-price text-end">
                            <div className="quantity-display">
                                <span className="text-muted small">Qty: </span>
                                <strong>{item.quantity}</strong>
                            </div>
                            <div className="price-display">
                                <ProductPrice priceInfo={item.productData.priceInfo} quantity={item.quantity} />
                            </div>
                        </div>
                        <button
                            className="btn btn__close btn-lg btn-link"
                            title="Remove from summary"
                            aria-label={`Remove ${item.id} from cart summary`}
                            onClick={() => updateRow(item.id, { quantity: '', disabled: true })}
                        >
                            <i className="fas fa-times-circle" />
                        </button>
                    </div>
                ))}
            </div>
            <div className="mt-3 mb-3 pt-3 border-top" style={{ zIndex: 3 }}>
                <BulkAddToCart
                    addToCartTip={addToCartTip}
                    cartIsUpdating={cartIsUpdating}
                    isLoading={isLoading}
                    isMobile={isMobile}
                    onBulkAddToCart={onBulkAddToCart}
                    selectedItems={selectedItems}
                />
            </div>

            {selectedItems?.items.length > 0 && (
                <div className="summary-actions mt-3 pt-3 ">
                    <div className={`d-flex justify-content-${!isMobile ? 'end' : 'center'} align-items-center`}>
                        <button
                            className="btn btn-outline-secondary"
                            onClick={clearAllInputs}
                            disabled={isLoading || cartIsUpdating}
                        >
                            <Translation id={clearItemsLabel} defaultValue="Clear All" />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

BuyBulkSummary.propTypes = {
    addToCartTip: px.object,
    cartIsUpdating: px.bool,
    clearAllInputs: px.func,
    facets: px.arrayOf(
        px.shape({
            Attribute: px.string,
            AttributeDefinition: px.string,
            AttributeDisplayName: px.string,
            AttributeFacetLabel: px.string,
            DependentAttribute: px.string,
            FacetColors: px.array,
            FacetRanges: px.array,
            FacetValues: px.array,
            SelectorControlType: px.string,
        })
    ),
    getFacetValueForProduct: px.func,
    getImageUrl: px.func,
    isLoading: px.bool,
    isMobile: px.bool,
    onBulkAddToCart: px.func,
    selectedItems: px.object,
    updateRow: px.func,
};
